import { makeStyles } from '@material-ui/core/styles'
import { VISIT_CARD_MOBILE_REDUCTION } from 'constants/breakpoints'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down(VISIT_CARD_MOBILE_REDUCTION)]: {
      padding: theme.spacing(1.5),
    },
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    '& h5': {
      [theme.breakpoints.down(800)]: {
        width: '11em',
      },
      [theme.breakpoints.down(VISIT_CARD_MOBILE_REDUCTION)]: {
        width: '8em',
      },
      [theme.breakpoints.down(400)]: {
        width: '6em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  },
  row: {
    display: 'flex',
    margin: `${theme.spacing(1)}px 0`,
  },
  bottomInfoContainer: {
    display: 'flex',
  },
  horizontalRowsContainer: {
    '& > div': {
      width: 'initial',
      flexWrap: 'wrap',
      '& > div': {
        marginRight: theme.spacing(5.5),
        justifyContent: 'initial',
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down(VISIT_CARD_MOBILE_REDUCTION)]: {
          marginRight: theme.spacing(2),
        },
        [theme.breakpoints.down(410)]: {
          marginRight: theme.spacing(1),
        },
      },
    },
  },
}))

export default useStyles
